<template>
  <div class="message_wrapper">
    <div class="message_wrapper-header">
      <div class="person-card" v-if="user_profile">
        <img v-if="user_profile.profile" :src="$fullUrl('images/profiles/' + user_profile.profile)" />
        <img v-else src="@/assets/avatar.png" alt />
        <div class="info-text">
          <h2>{{ user_profile.names | validate }}</h2>
          <span>{{ user_profile.job | validate }}</span>
        </div>
      </div>
    </div>
    <div class="message_wrapper-body">
      <div class="message-container">
        <div class="conversation-widget" :class="{ is_messaging: is_messaging }">
          <div class="conversation-header">
            <div class="conversation-header-ribbon">
              <h2 v-if="new_message">New Message</h2>
              <h2 v-else>Messages</h2>
              <button v-if="!new_message" class="btn-new-message" @click="addNewMessage()">
                New Message
                <img class="icon" src="@/assets/icons/plus-white.svg" />
              </button>
              <button v-if="new_message" class="btn-back" @click="closeNewMessage()">
                <img src="@/assets/icons/fill-white-back.svg" /> Back
              </button>
            </div>
            <div class="conversation-header-search">
              <widgetSearch v-model="search_conversation_input" placeholder="Type in to Search…" icon="right">
              </widgetSearch>
            </div>
          </div>

          <!-- ====================== -->
          <!-- Conversation list -->
          <div v-if="!new_message &&
            !conversation_loading &&
            message_conversation.length > 0
            " class="conversation-body">
            <div class="conversation-list">
              <div class="conversation-list-body">
                <div class="conversation-list-item" v-for="(item, index) in message_conversation" :key="index" :class="{
                  active: form_message.receiver_id == item.user.id,
                }" @click="openChat(item)">
                  <div class="profile-widget">
                    <img v-if="item.user.profile_picture" class="profile-image" :src="$fullUrl('images/profiles/' + item.user.profile_picture)
                      " />
                    <img v-else class="profile-image" src="@/assets/avatar.png" />
                    <div v-if="item.is_online" class="online-dot"></div>
                  </div>
                  <div class="conversation-item-content">
                    <div class="conversation-item-content-header">
                      <div class="names">
                        {{ item.user.first_name + " " + item.user.last_name }}
                      </div>
                      <div class="date">
                        {{ validateMessageTime(item.latestMessage.created_at) }}
                      </div>
                    </div>
                    <div class="conversation-item-content-body">
                      <span v-html="item.latestMessage.message"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Conversation loading -->
          <div v-if="conversation_loading" class="coversation-loading-widget">
            <div class="loading-item" v-for="(item, index) in 6" :key="index">
              <div class="row-2">
                <div class="item pulse"></div>
                <div class="item pulse"></div>
              </div>
              <div class="row">
                <div class="item pulse" style="height: 10px"></div>
                <div class="item pulse" style="height: 10px"></div>
              </div>
            </div>
          </div>

          <!--  When no contact message -->
          <div v-if="!new_message &&
            !conversation_loading &&
            message_conversation.length == 0
            " class="conversation-empty-widget">
            <img class="main" src="@/assets/icons/message-search-empty.svg" />
            <h2>No Contacts</h2>
            <p>Start sending message by clicking button below</p>
            <button v-if="!new_message" class="btn-new-message" @click="addNewMessage()">
              New Message
              <img class="icon" src="@/assets/icons/plus-white.svg" />
            </button>
          </div>

          <!-- When searching for new message -->
          <div v-if="new_message && !loading_contact && contact_list.length > 0"
            class="search-contact-new-message-widget">
            <div class="search-result">
              <div class="search-result-header">Search Results</div>
              <div class="contact-item" v-for="(item, index) in contact_list" :key="index" @click="openNewChat(item)">
                <div class="profile-widget">
                  <img v-if="item.profile_picture" class="profile-image"
                    :src="$fullUrl('images/profiles/' + item.profile_picture)" />
                  <img v-else class="profile-image" src="@/assets/avatar.png" />
                  <div v-if="index == -1" class="online-dot"></div>
                </div>
                <div class="contact-content">
                  <div class="names">
                    {{ (item.first_name + " " + item.last_name) | validate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Contact loading -->
          <div class="contact-loading-widget" v-if="new_message && loading_contact">
            <div class="loading-item" v-for="(item, index) in 5" :key="index">
              <div class="row-2">
                <div class="item pulse"></div>
                <div class="item pulse"></div>
              </div>
              <div class="row">
                <div class="item pulse" style="height: 60px"></div>
              </div>
            </div>
          </div>
          <!-- Empty search widget -->
          <div class="search-empty" v-if="new_message && !loading_contact && contact_list.length == 0">
            <img src="@/assets/icons/message-search-empty.svg" />
            <h2>No Contacts</h2>
            <p>Search contact on the top to start sending message</p>
          </div>
          <!-- ======================== -->
        </div>
        <div class="message-divider"></div>
        <div class="message-widget" :class="{ is_messaging: is_messaging }">
          <div class="message-chats" v-if="!message_loading && message_chat.receiver">
            <div class="message-widget-header" v-if="message_chat.receiver">
              <div class="profile-widget" :class="{ is_message_searching: is_message_searching }">
                <div class="profile-option">
                  <button class="btn-back" @click="backToContact()">
                    <img src="@/assets/icons/back-gray.svg" />
                  </button>
                </div>
                <div class="profile-image">
                  <img v-if="message_chat.receiver.profile_picture" class="profile-image" :src="$fullUrl(
                    'images/profiles/' +
                    message_chat.receiver.profile_picture
                  )
                    " />
                  <img v-else class="profile-image" src="@/assets/avatar.png" />
                  <div v-if="message_chat.is_online" class="online-dot"></div>
                </div>
                <div class="profile-info">
                  <div class="names">
                    {{
                      message_chat.receiver.first_name +
                      " " +
                      message_chat.receiver.last_name
                    }}
                  </div>
                  <div class="online-status" v-if="message_chat.is_online">
                    {{ is_typing ? "Typing..." : " Online" }}
                  </div>
                  <div class="online-status" v-else>{{ "Offline" }}</div>
                </div>
              </div>
              <div class="message-options" :class="{ is_message_searching: is_message_searching }">
                <div class="message-search-widget" :class="{ is_message_searching: is_message_searching }">
                  <button class="btn-back" @click="backToMessage()">
                    <img src="@/assets/icons/back-gray.svg" />
                  </button>
                  <div class="search-widget">
                    <img src="@/assets/icons/conversation-search.svg" />
                    <input class="search-input" type="text" placeholder="Search for a message"
                      v-model="search_message_input" />
                  </div>
                </div>
                <div class="message-phone-options" :class="{ is_message_searching: is_message_searching }">
                  <button class="btn-search" v-if="false" @click="startSearchMessage()">
                    <img src="@/assets/icons/dark-search.svg" />
                  </button>
                </div>
              </div>
            </div>
            <div class="message-widget-body" id="message-body" v-chat-scroll="{
              always: false,
              smooth: true,
              notSmoothOnInit: true,
            }">
              <ul class="message-list" v-if="message_chat.messages.length > 0">
                <li v-for="(item, index) in message_chat.messages" :class="{
                  'message-receiver': item.sender_id === user_profile.id,
                  'message-sender': item.sender_id != user_profile.id,
                }" :key="index">
                  <div class="message-content">
                    <div class="image-message" v-if="item.new_file_name && item.file_type == 'image'">
                      <img :src="$fullUrl('files/messages/' + item.new_file_name)" />
                    </div>
                    <div class="video-message" v-if="item.new_file_name && item.file_type == 'video'">
                      <video controls :src="$fullUrl('files/messages/' + item.new_file_name)" />
                    </div>

                    <div class="audio-message" v-if="item.new_file_name && item.file_type == 'audio'">
                      <audio controls :src="$fullUrl('files/messages/' + item.new_file_name)" />
                    </div>

                    <div class="audio-message" v-if="item.new_file_name && item.file_type == 'voice'">
                      <audio controls :src="$fullUrl('files/messages/' + item.new_file_name)" />
                    </div>

                    <div class="document-message" v-if="item.new_file_name && item.file_type == 'file'">
                      <div class="document-widget">
                        <img src="@/assets/file-icon/file.svg" />
                        <h4>{{ item.new_file_name }}</h4>
                      </div>
                      <a class="btn-download" :href="$fullUrl('files/messages/' + item.new_file_name)" target="_blank"
                        download="true">Download</a>
                    </div>
                    <span v-html="urlify(item.message)"></span>
                  </div>
                  <div class="massage-time">
                    {{ validateMessageTime(item.created_at) }}
                  </div>
                </li>
              </ul>
            </div>
            <div class="message-widget-footer" v-if="message_chat.receiver">
              <div class="message-input-widget-wrapper">
                <div class="message-input-widget">
                  <div class="file-widget-wrapper">
                    <!-- File widget -->
                    <div v-if="form_message.is_file_message" class="preview-file-widget">
                      <div class="image-widget" v-if="form_message.file_type == 'image'">
                        <div class="file-widget-options">
                          <h2>Photo</h2>
                          <button @click="removeFile()" class="btn-remove">
                            Remove
                          </button>
                        </div>
                        <img class="image-preview" :src="form_message.image.blob" />
                      </div>
                      <div class="video-widget" v-if="form_message.file_type == 'video'">
                        <div class="file-widget-options">
                          <h2>Video</h2>
                          <button @click="removeFile()" class="btn-remove">
                            Remove
                          </button>
                        </div>
                        <video class="video-preview" :src="form_message.video.blob" controls />
                      </div>
                      <div class="file-widget" v-if="form_message.file_type == 'file'">
                        <div class="document-widget">
                          <img src="@/assets/file-icon/file.svg" />
                          <h4>{{ form_message.file_name }}</h4>
                        </div>
                        <div class="file-widget-options">
                          <button @click="removeFile()" class="btn-remove">
                            &times;
                          </button>
                        </div>
                      </div>
                      <div>
                        <progressBar class="p-success" v-model="progress_file_upload"></progressBar>
                      </div>
                    </div>
                    <!-- End of file widget -->
                  </div>
                  <textarea class="message-input" :class="{ typing: is_typing_message }" @focus="is_typing_message = true"
                    placeholder="Type Here..." v-model="form_message.text"></textarea>
                </div>
                <div class="message-files-options">
                  <!-- Emoji widget -->
                  <emoji-picker @emoji="insert" :search="search_emoji">
                    <div slot="emoji-invoker" slot-scope="{ events: { click: clickEvent } }" @click.stop="clickEvent">
                      <button class="btn-emoji">
                        <img src="@/assets/icons/chat-emoji.svg" />
                      </button>
                    </div>
                    <div class="emoji-widget" slot="emoji-picker" slot-scope="{ emojis, insert, display }">
                      <div class="emoji-widget-header">
                        <div class="emoji-tabs">
                          <div class="emoji-tab" v-for="(emojiGroup, category) in emojis" :key="category"
                            @click="selectEmojiCategory(category)">
                            <span :class="{
                              [category]: true,
                              active: category == selected_emoji_tab,
                            }"></span>
                          </div>
                        </div>
                      </div>
                      <div class="emoji-widget-body">
                        <template v-for="(emojiGroup, category) in emojis">
                          <div v-if="category == selected_emoji_tab" :key="category" class="emoji-container">
                            <div class="search-emoji-widget">
                              <input placeholder="Search emoji" type="text" v-model="search_emoji" />
                            </div>
                            <div class="emoji-icons-widget">
                              <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="insert(emoji)"
                                :title="emojiName">{{ emoji }}</span>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </emoji-picker>
                  <!-- Emoji end widget -->
                  <MessageFileWidget @fileSelected="onFileSelected" @uploadProgress="onUploadProgress"
                    @uploadCompleted="onUploadCompleted">
                    <button class="btn-photo">
                      <img src="@/assets/icons/attach-file-gray.svg" />
                    </button>
                  </MessageFileWidget>

                  <!-- File end widget -->
                  <button class="btn-microphone" v-if="false">
                    <img src="@/assets/icons/microphone.svg" />
                  </button>
                </div>
              </div>
              <div class="message-option">
                <button class="btn-send" @click="sendMessage()">
                  <img src="@/assets/icons/send-white.svg" />
                </button>
              </div>
            </div>
          </div>
          <div v-if="message_loading" class="message-loading-widget">
            <div class="message-loading-header">
              <div class="profile-image pulse"></div>
              <div class="profile-content">
                <div class="item pulse"></div>
                <div class="item pulse"></div>
              </div>
            </div>
            <div class="message-loading-body">
              <ul class="message-list">
                <li v-for="(item, index) in 10" :class="{
                  pulse: true,
                  'message-receiver': index % 2 == 0,
                  'message-sender': index % 2 != 0,
                }" :key="index">
                  <div class="message-content"></div>
                  <div class="massage-time"></div>
                </li>
              </ul>
            </div>
            <div class="message-loading-footer">
              <div class="item pulse"></div>
            </div>
          </div>
          <div v-if="!message_loading && !message_chat.receiver" class="message-empty-widget">
            <img class="main" src="@/assets/icons/message-empty-chat.svg" />
            <h2>No messages selected</h2>
            <p>
              All your contact messages will appear here, select one of your
              contact or add new message
            </p>
            <button v-if="!new_message" class="btn-new-message" @click="addNewMessage()">
              New Message
              <img class="icon" src="@/assets/icons/plus-white.svg" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "../main";
import EmojiPicker from "vue-emoji-picker";
import MessageFileWidget from "@/components/MessageFileWidget.vue";
export default {
  name: "Message",
  components: {
    EmojiPicker,
    MessageFileWidget,
  },
  computed: {},
  sockets: {
    connect: function () { },
    register: function (id) {
      let vm = this;
      vm.message_conversation.forEach((item) => {
        if (item.user.id == id) {
          eventBus.$set(item, "is_online", true);
        }
      });
      if (vm.message_chat.receiver) {
        if (vm.message_chat.receiver.id == id) {
          eventBus.$set(vm.message_chat, "is_online", true);
        }
      }
    },
    message: function (payload) {
      let vm = this;
      if (payload.id === vm.user_profile.id) {
        vm.getUserConversation("chat");
        vm.playSound();
        if (vm.message_chat.receiver) {
          if (payload.sender.id == vm.message_chat.receiver.id) {
            vm.message_chat.messages.push(payload.data);
          }
        }
      }
    },
    typing: function (payload) {
      let vm = this;
      if (vm.message_chat.receiver) {
        if (payload.me_id == vm.user_profile.id) {
          if (payload.user_id == vm.message_chat.receiver.id) {
            vm.is_typing = true;
          }
        }
      }
    },
    not_typing: function (payload) {
      let vm = this;
      if (vm.message_chat.receiver) {
        if (payload.me_id == vm.user_profile.id) {
          if (payload.user_id == vm.message_chat.receiver.id) {
            vm.is_typing = false;
          }
        }
      }
    },
    is_online: function (payload) {
      let vm = this;
      vm.message_conversation.forEach((item) => {
        if (item.user.id == payload.id) {
          eventBus.$set(item, "is_online", payload.isOnline);
        }
      });
      if (vm.message_chat.receiver) {
        if (vm.message_chat.receiver.id == payload.id) {
          eventBus.$set(vm.message_chat, "is_online", payload.isOnline);
        }
      }
    },
    leaving: function (id) {
      let vm = this;
      vm.message_conversation.forEach((item) => {
        if (item.user.id == id) {
          eventBus.$set(item, "is_online", false);
        }
      });
      if (vm.message_chat.receiver) {
        if (vm.message_chat.receiver.id == id) {
          eventBus.$set(vm.message_chat, "is_online", false);
        }
      }
    },
  },
  data() {
    return {
      sound: require("@/assets/audio/sound.mp3"),
      audio: null,
      new_message: false,
      is_typing: false,
      form_message: {
        is_file_message: false,
        file_type: "",
        new_file_name: "",
        file_name: "",
        file: null,
        image: null,
        video: null,
        text: "",
        receiver_id: null,
        channel: "",
      },
      search_conversation_input: "",
      search_message_input: "",
      contact_list: [],
      message_conversation: [],
      message_chat: {
        receiver: null,
        is_online: false,
        messages: [],
      },
      user_profile: null,
      owner_user_profile: null,
      search_emoji: "",
      selected_emoji_tab: "People",
      is_typing_message: false,
      loading_contact: false,
      message_loading: false,
      conversation_loading: false,
      is_messaging: false,
      is_message_searching: false,
      progress_file_upload: 0,
      tyiping_timer: 0,
    };
  },
  mounted() {
    let vm = this;
    vm.audio = new Audio(vm.sound);
    vm.getUserData();
  },
  methods: {
    urlify(text) {
      if (text) {
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function (url) {
          return '<a target="_blank" href="' + url + '">' + url + "</a>";
        });
      }
    },
    playSound() {
      this.audio.play();
    },
    removeFile() {
      let vm = this;
      vm.form_message.is_file_message = false;
      vm.form_message.file_type = "";
      vm.form_message.file = null;
      vm.form_message.image = null;
      vm.form_message.video = null;
      vm.form_message.file_name = "";
    },
    onUploadCompleted(data) {
      let vm = this;
      let new_file_name = data[0].response.name;
      vm.form_message.new_file_name = new_file_name;
      vm.sendFileMessage();
    },
    onUploadProgress(data) {
      let vm = this;
      vm.progress_file_upload = parseInt(data[0].progress);
    },
    onFileSelected(data) {
      let vm = this;
      vm.form_message.is_file_message = true;
      vm.form_message.file_type = data.file_type;
      vm.form_message.file = data.file;
      vm.form_message.image = data.image;
      vm.form_message.video = data.video;
      vm.form_message.file_name = data.file_name;
    },
    backToMessage() {
      let vm = this;
      vm.is_message_searching = false;
    },
    startSearchMessage() {
      let vm = this;
      vm.is_message_searching = true;
    },
    backToContact() {
      let vm = this;
      vm.is_messaging = false;
    },
    closeNewMessage() {
      let vm = this;
      vm.new_message = false;
    },
    addNewMessage() {
      let vm = this;
      vm.new_message = true;
    },
    searchContact(query) {
      let vm = this;
      vm.loading_contact = true;
      vm.$store
        .dispatch("MESSAGE_SEARCH_CONTACT", {
          q: query,
        })
        .then((response) => {
          vm.loading_contact = false;
          vm.contact_list = response.data;
        })
        .catch((error) => {
          vm.loading_contact = false;
          console.log(error);
        });
    },
    searchMessage(quely) {
      let vm = this;
      vm.$store
        .dispatch("MESSAGE_SEARCH_SMS", {
          quely: quely,
          receiver_id: vm.form_message.receiver_id,
        })
        .then((response) => {
          vm.message_chat.messages = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    searchConversation(query) {
      let vm = this;
      vm.$store
        .dispatch("MESSAGE_SEARCH_CONVERSATION", {
          q: query,
        })
        .then((response) => {
          vm.message_conversation = response.data
            .map((item) => {
              if (item.invitee_id !== vm.user_profile.id) {
                eventBus.$set(item, "user", item.invitee);
              } else {
                eventBus.$set(item, "user", item.inviter);
              }
              return item;
            })
            .filter((item) => item.user != null)
            .map((item, index) => {
              if (item.invitee_id !== vm.user_profile.id) {
                eventBus.$set(item, "is_online", false);
                vm.$socket.emit("is_online", {
                  index: index,
                  id: item.user.id,
                });
              } else {
                eventBus.$set(item, "is_online", false);
                vm.$socket.emit("is_online", {
                  index: index,
                  id: item.user.id,
                });
              }
              return item;
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sendFileMessage() {
      let vm = this;
      vm.$store
        .dispatch("MESSAGE_SEND_SMS", vm.form_message)
        .then((response) => {
          vm.resetMessage();
          vm.message_chat.messages.push(response.data);
          vm.getUserConversation();
          vm.notify(
            vm.form_message.receiver_id,
            response.data,
            vm.owner_user_profile,
            vm.form_message.channel
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sendMessage() {
      let vm = this;
      if (vm.form_message.is_file_message) {
        eventBus.$emit("startUpload", null);
      } else {
        if (vm.form_message.text) {
          vm.$store
            .dispatch("MESSAGE_SEND_SMS", vm.form_message)
            .then((response) => {
              vm.resetMessage();
              vm.message_chat.messages.push(response.data);
              vm.getUserConversation();
              vm.notify(
                vm.form_message.receiver_id,
                response.data,
                vm.owner_user_profile,
                vm.form_message.channel
              );
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },
    notify(userId, chat, sender, channel) {
      let vm = this;
      let data = {
        id: userId,
        data: chat,
        sender: sender,
        channel: channel,
      };
      vm.$socket.emit("message", data);
    },

    resetMessage() {
      let vm = this;
      vm.form_message.text = "";
      vm.form_message.is_file_message = false;
      vm.form_message.file_type = "";
      vm.form_message.file = null;
      vm.form_message.image = null;
      vm.form_message.video = null;
      vm.form_message.file_name = "";
    },
    openChat(item) {
      let vm = this;
      vm.message_loading = true;
      vm.message_chat.receiver = item.user;
      vm.is_typing_message = false;
      vm.form_message.receiver_id = item.user.id;
      vm.form_message.channel = item.user.channel;
      vm.resetMessage();
      vm.is_messaging = true;
      vm.$store
        .dispatch("MESSAGE_GET_CHAT", {
          receiver_id: item.user.id,
        })
        .then((response) => {
          vm.message_loading = false;
          vm.$socket.emit("is_online", { index: 0, id: item.user.id });
          vm.message_chat.messages = response.data;
        })
        .catch((error) => {
          vm.message_loading = false;
          console.log(error);
        });
    },
    openNewChat(item) {
      let vm = this;
      vm.message_loading = true;
      vm.new_message = false;
      vm.search_conversation_input = "";
      vm.message_chat.receiver = item;
      vm.is_typing_message = false;
      vm.form_message.receiver_id = item.id;
      vm.form_message.channel = item.channel;
      vm.is_messaging = true;
      vm.resetMessage();
      vm.$store
        .dispatch("MESSAGE_GET_CHAT", {
          receiver_id: item.id,
        })
        .then((response) => {
          vm.message_loading = false;
          vm.$socket.emit("is_online", { index: 0, id: item.id });
          vm.message_chat.messages = response.data;
          var messageBody = document.getElementById("message-body");
          messageBody.scrollTop = messageBody.scrollHeight;
        })
        .catch((error) => {
          vm.message_loading = false;
          console.log(error);
        });
    },
    getUserConversation(type = "chat") {
      let vm = this;
      if (type == "new") {
        vm.conversation_loading = true;
      }
      vm.$store
        .dispatch("MESSAGE_CONVERSATION")
        .then((response) => {
          vm.conversation_loading = false;
          vm.message_conversation = response.data
            .map((item) => {
              if (item.invitee_id !== vm.user_profile.id) {
                eventBus.$set(item, "user", item.invitee);
              } else {
                eventBus.$set(item, "user", item.inviter);
              }
              return item;
            })
            .filter((item) => item.user != null)
            .map((item, index) => {
              if (item.invitee_id !== vm.user_profile.id) {
                eventBus.$set(item, "is_online", false);
                vm.$socket.emit("is_online", {
                  index: index,
                  id: item.user.id,
                });
              } else {
                eventBus.$set(item, "is_online", false);
                vm.$socket.emit("is_online", {
                  index: index,
                  id: item.user.id,
                });
              }
              return item;
            });
        })
        .catch((error) => {
          vm.conversation_loading = false;
          console.log(error);
        });
    },
    getUserData() {
      let vm = this;
      vm.$store
        .dispatch("GET_ME_PROFILE_DATA")
        .then((response) => {
          let data = response.data;
          vm.owner_user_profile = data.user;
          vm.user_profile = {
            id: data.user.id,
            profile: data.user.profile_picture,
            names: data.user.first_name + " " + data.user.last_name,
            email: data.user.email,
            phone: data.profile.phone,
            job:
              data.employment.length > 0 ? data.employment[0].company.name : "",
            description: data.profile.description,
          };
          vm.getUserConversation("new");
        })
        .catch((error) => { });
    },
    insert(emoji) {
      let vm = this;
      vm.form_message.text += emoji;
    },
    selectEmojiCategory(category) {
      let vm = this;
      vm.selected_emoji_tab = category;
    },
  },
  watch: {
    "form_message.text"(val) {
      let vm = this;
      if (val) {
        vm.$socket.emit("typing", {
          user_id: vm.user_profile.id,
          me_id: vm.message_chat.receiver.id,
        });
      }
      clearTimeout(vm.tyiping_timer);
      vm.tyiping_timer = setTimeout(() => {
        vm.$socket.emit("not_typing", {
          user_id: vm.user_profile.id,
          me_id: vm.message_chat.receiver.id,
        });
      }, 1000);
    },
    search_conversation_input(quely) {
      let vm = this;
      if (!vm.new_message) {
        if (quely) {
          vm.searchConversation(quely);
        } else {
          vm.getUserConversation();
        }
      } else {
        vm.searchContact(quely);
      }
    },
    search_message_input(quely) {
      let vm = this;
      vm.searchMessage(quely);
    },
  },
};
</script>


<style lang="scss" scoped>
.message_wrapper {
  background: rgba(239, 239, 239, 0.49);
  position: fixed;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  padding-top: 55px;
  display: flex;
  flex-direction: column;

  @media (min-width: 300px) and (max-width: 630px) {
    bottom: 56px;
  }

  .message_wrapper-header {
    height: 70px;
    background-image: url("../assets/images/backgrounds/wallpaper.svg");
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (min-width: 30px) and (max-width: 800px) {
      display: none;
    }

    .person-card {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;

      img {
        width: 40px;
        height: 40px;
        margin-right: 15px;
        border-radius: 50%;
        object-fit: contain;
      }

      .info-text {
        h2 {
          color: #fff;
          margin: 0px;
          font-size: 17px;
          font-weight: bold;

          @media (min-width: 300px) and (max-width: 630px) {
            font-size: 15px;
          }
        }

        span {
          color: #fff;
        }
      }
    }
  }

  .message_wrapper-body {
    height: calc(100% - 70px);
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 20px 0px;

    @media (min-width: 30px) and (max-width: 800px) {
      padding: 0px 0px;
      height: 100%;
    }

    .message-container {
      background: #fff;
      border-radius: 10px;
      display: flex;
      padding: 16px;
      width: 800px;
      height: 100%;

      @media (min-width: 30px) and (max-width: 800px) {
        width: 100%;
        padding: 0px;
      }

      .conversation-widget {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 300px;

        @media (min-width: 30px) and (max-width: 800px) {
          width: 100%;
          padding: 10px;
          margin-top: 10px;
          margin-right: 0px;
        }

        &.is_messaging {
          @media (min-width: 30px) and (max-width: 800px) {
            display: none;
          }
        }

        .conversation-header {
          height: 110px;

          .conversation-header-ribbon {
            display: flex;
            justify-content: space-between;
            align-items: center;

            h2 {
              font-size: 16px;
              margin: 0px;
            }

            .btn-new-message {
              display: flex;
              align-items: center;
              background: #0884af;
              border-radius: 10px;
              font-size: 13px;
              padding: 0px 13px;
              color: #fff;
              height: 40px;
              font-weight: bold;

              img {
                margin-left: 4px;
                margin-right: 5px;
                width: 15px;
                height: 15px;
                position: relative;
                top: 0px;
              }
            }

            .btn-back {
              display: flex;
              align-items: center;
              background: #1ba5a4;
              border-radius: 5px;
              font-size: 13px;
              padding: 0px 13px;
              color: #1ba5a4;
              color: #fff;
              height: 40px;

              img {
                margin-right: 5px;
                width: 15px;
                height: 15px;
                position: relative;
                top: -1px;
              }
            }
          }

          .conversation-header-search {
            margin-top: 13px;
            padding: 0px 0px;
          }
        }

        .conversation-body {
          height: calc(100% - 110px);
          overflow-y: auto;
          line-height: normal;

          .conversation-list {
            margin-bottom: 30px;

            .conversation-list-header {
              color: #676767;
              padding: 0px 0px;
            }

            .conversation-list-body {
              .conversation-list-item:nth-child(1) {
                .conversation-item-content {}
              }

              .conversation-list-item {
                display: flex;
                padding: 0px 5px;
                cursor: pointer;
                border-radius: 10px;

                &:hover {
                  background: #f4f4f4;
                }

                &.active {
                  background: #f4f4f4;
                }

                .profile-widget {
                  margin-right: 8px;
                  position: relative;
                  height: 70px;
                  display: flex;
                  align-items: center;

                  .profile-image {
                    height: 50px;
                    width: 50px;
                    border-radius: 50%;
                  }

                  .online-dot {
                    height: 12px;
                    width: 12px;
                    background: #1ba5a4;
                    border: 1.5px solid #ffffff;
                    border-radius: 50%;
                    position: absolute;
                    bottom: 10px;
                    right: -1px;
                  }
                }

                .conversation-item-content {
                  display: flex;
                  flex-direction: column;
                  width: calc(100% - 60px);
                  justify-content: center;

                  .conversation-item-content-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;

                    .names {
                      font-size: 14px;
                      color: #000000;
                      overflow: hidden;
                      text-decoration: none;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      width: 100px;
                      font-weight: 600;
                    }

                    .date {
                      font-size: 10px;
                      color: #646464;
                      position: relative;
                      top: 9px;
                    }
                  }

                  .conversation-item-content-body {
                    margin-top: 2px;
                    width: 100%;
                    font-size: 12px;
                    color: #646464;
                    overflow: hidden;
                    text-decoration: none;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
              }
            }
          }
        }

        .coversation-loading-widget {
          display: flex;
          flex-direction: column;
          height: calc(100% - 95px);
        }

        .conversation-empty-widget {
          width: 100%;
          height: calc(100% - 95px);
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 70px;
          padding: 30px;

          img.main {
            margin-bottom: 35px;

            @media (min-width: 30px) and (max-width: 800px) {
              width: 100px;
            }
          }

          p {
            color: #676767;
            text-align: center;
          }

          .btn-new-message {
            display: flex;
            align-items: center;
            background: #0884af;
            border-radius: 10px;
            font-size: 13px;
            padding: 0px 13px;
            color: #fff;
            height: 40px;
            font-weight: bold;

            img {
              margin-left: 4px;
              margin-right: 5px;
              width: 15px;
              height: 15px;
              position: relative;
              top: 0px;
            }
          }
        }

        .contact-loading-widget {
          display: flex;
          flex-direction: column;
          height: calc(100% - 95px);
        }

        .search-contact-new-message-widget {
          display: flex;
          flex-direction: column;
          height: calc(100% - 95px);
          overflow-y: auto;
          padding-top: 5px;

          .search-result {
            display: flex;
            flex-direction: column;

            .search-result-header {
              color: #676767;
            }

            .contact-item {
              display: flex;
              align-items: center;
              cursor: pointer;
              padding: 10px 10px;
              border-radius: 5px;

              &:hover {
                background: rgb(238, 237, 237);
              }

              .profile-widget {
                margin-right: 8px;
                position: relative;
                height: 40px;

                .profile-image {
                  height: 40px;
                  width: 40px;
                  border-radius: 50%;
                }

                .online-dot {
                  height: 12px;
                  width: 12px;
                  background: #1ba5a4;
                  border: 1.5px solid #ffffff;
                  border-radius: 50%;
                  position: absolute;
                  bottom: 5px;
                  right: -1px;
                }
              }
            }
          }
        }

        .search-empty {
          height: calc(100% - 95px);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          img {
            margin-bottom: 30px;
            width: 100px;
          }

          h2 {
            margin-bottom: 15px;
          }

          p {
            text-align: center;
            color: #676767;
          }
        }
      }

      .message-divider {
        height: calc(100% - 183px);
        width: 1px;
        background: #ddd;
        margin-top: 108px;
        margin-left: 13px;
        margin-right: 13px;
      }

      .message-widget {
        width: calc(100% - 300px);
        height: 100%;
        display: flex;
        flex-direction: column;

        @media (min-width: 30px) and (max-width: 800px) {
          display: none;
          width: 100%;
          margin-top: 7px;
        }

        &.is_messaging {
          @media (min-width: 30px) and (max-width: 800px) {
            display: flex;
          }
        }

        .message-chats {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;

          .message-widget-header {
            height: 70px;
            border-bottom: 1px solid #ededed;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px 10px;

            .profile-widget {
              margin-right: 8px;
              display: flex;
              align-items: center;

              &.is_message_searching {
                display: none;
              }

              .profile-option {
                margin: 0px 10px;
                display: none;

                @media (min-width: 30px) and (max-width: 800px) {
                  display: flex;
                }

                .btn-back {
                  img {
                    width: 10px;
                  }
                }
              }

              .profile-image {
                position: relative;
                display: flex;
                align-items: center;

                img {
                  height: 50px;
                  width: 50px;
                  border-radius: 50%;
                  margin-right: 14px;
                }

                .online-dot {
                  height: 12px;
                  width: 12px;
                  background: #1ba5a4;
                  border: 1.5px solid #ffffff;
                  border-radius: 50%;
                  position: absolute;
                  bottom: 10px;
                  right: 10px;
                }
              }

              .profile-info {
                display: flex;
                flex-direction: column;

                .names {
                  font-size: 14px;
                  color: #000;
                  font-weight: 600;
                }

                .online-status {
                  font-size: 12px;
                  color: #676767;
                }
              }
            }

            .message-options {
              &.is_message_searching {
                width: 100%;
              }

              .message-search-widget {
                display: none;
                align-items: center;
                width: 100%;

                &.is_message_searching {
                  display: flex;
                }

                .btn-back {
                  margin: 0px 10px;
                  display: flex;
                  align-items: center;

                  img {
                    width: 10px;
                  }
                }

                .search-widget {
                  border-radius: 5px;
                  border: 1px solid #ddd;
                  display: flex;
                  align-items: center;
                  padding: 0px 10px;
                  height: 38px;
                  background: #fff;
                  width: 100%;

                  img {
                    margin-right: 4px;
                    width: 20px;
                    height: 20px;
                    object-fit: contain;
                  }

                  .search-input {
                    border: none;
                    outline: none;
                    width: 100%;
                  }
                }
              }

              .message-phone-options {
                display: flex;
                margin-right: 10px;

                &.is_message_searching {
                  display: none;
                }
              }
            }
          }

          .message-widget-body {
            height: 100%;
            overflow-y: auto;
            padding: 15px 10px;

            .message-list {
              list-style: none;
              padding-left: 0px;
              width: 100%;

              .message-sender {
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                margin-bottom: 10px;
                width: 100%;

                .message-content {
                  max-width: 70%;
                  background: #eaeaea;
                  border-radius: 10px 10px 10px 0px;
                  padding: 14px;
                  color: #000;
                  margin-bottom: 4px;
                  text-align: justify;

                  .image-message {
                    width: 100%;

                    img {
                      width: 100%;
                    }
                  }

                  .video-message {
                    width: 100%;

                    video {
                      width: 100%;
                    }
                  }

                  .audio-message {
                    width: 100%;

                    audio {
                      width: 100%;
                    }
                  }

                  .document-message {
                    .btn-download {
                      display: flex;
                      align-items: center;
                      background: #1ba5a4;
                      border-radius: 5px;
                      font-size: 13px;
                      padding: 0px 13px;
                      color: #fff;
                      height: 40px;
                    }
                  }

                  span {
                    line-height: 10px;

                    a {
                      color: #28a5a4 !important;
                    }
                  }
                }

                .massage-time {
                  font-size: 12px;
                  color: #717171;
                }

                .typing-message {
                  background: #fff;
                  border-radius: 6px 6px 6px 0px;
                  padding: 14px;
                  color: #000;
                  margin-bottom: 4px;
                  align-self: flex-start;
                  text-align: justify;
                  cursor: pointer;
                }
              }

              .message-receiver {
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                margin-bottom: 10px;
                width: 100%;

                .message-content {
                  background: #1ba5a4;
                  max-width: 70%;
                  border-radius: 10px 10px 0px 10px;
                  padding: 14px;
                  color: #fff;
                  margin-bottom: 4px;
                  align-self: flex-end;
                  text-align: justify;

                  .image-message {
                    width: 100%;

                    img {
                      width: 100%;
                    }
                  }

                  .video-message {
                    width: 100%;

                    video {
                      width: 100%;
                    }
                  }

                  .document-message {
                    .btn-download {
                      display: flex;
                      align-items: center;
                      background: #1ba5a4;
                      border-radius: 5px;
                      font-size: 13px;
                      padding: 0px 13px;
                      color: #fff;
                      height: 40px;
                    }
                  }

                  span {
                    line-height: 10px;

                    a {
                      color: #28a5a4 !important;
                    }
                  }
                }

                .massage-time {
                  font-size: 12px;
                  color: #717171;
                  align-self: flex-end;
                }
              }
            }
          }

          .message-widget-footer {
            border-top: 1px solid #ededed;
            display: flex;
            padding: 10px 0px;

            .message-input-widget-wrapper {
              width: calc(100% - 35px);
              background: #fff;
              margin-right: 10px;
              border-radius: 10px;
              padding: 5px 0px;
              display: flex;
              border: 1px solid #ddd;

              .message-input-widget {
                width: 95%;

                .file-widget-wrapper {
                  position: relative;

                  .preview-file-widget {
                    position: absolute;
                    bottom: 5px;
                    background: #fff;
                    right: -1px;
                    left: -1px;
                    display: flex;
                    flex-direction: column;
                    padding: 10px;
                    border-left: 1px solid #ddd;
                    border-right: 1px solid #ddd;
                    border-top: 1px solid #ddd;
                    border-bottom: 1px solid #ddd;
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;

                    .image-widget {
                      .image-preview {
                        width: 100%;
                      }

                      .file-widget-options {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding-bottom: 10px;

                        h2 {}

                        .btn-remove {
                          display: flex;
                          align-items: center;
                          background: #1ba5a4;
                          border-radius: 5px;
                          font-size: 13px;
                          padding: 0px 13px;
                          color: #fff;
                          height: 40px;
                        }
                      }
                    }

                    .video-widget {
                      .video-preview {
                        width: 100%;
                      }

                      .file-widget-options {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding-bottom: 10px;

                        h2 {}

                        .btn-remove {
                          display: flex;
                          align-items: center;
                          background: #1ba5a4;
                          border-radius: 5px;
                          font-size: 13px;
                          padding: 0px 13px;
                          color: #fff;
                          height: 40px;
                        }
                      }
                    }

                    .file-widget {
                      display: flex;
                      margin-bottom: 10px;
                      justify-content: space-between;

                      .document-widget {
                        display: flex;
                        align-items: center;
                        width: 96%;

                        img {
                          margin-right: 10px;
                        }

                        h4 {
                          overflow: hidden;
                          text-decoration: none;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          width: 100%;
                        }
                      }

                      .file-widget-options {
                        display: flex;
                        align-items: center;

                        .btn-remove {
                          font-size: 25px;
                        }
                      }
                    }
                  }
                }

                .message-input {
                  width: 100%;
                  outline: none;
                  resize: none;
                  height: 23px;
                  padding: 0px 10px;
                  transition: 500ms ease-in-out;
                  padding-top: 4px;

                  &:focus {
                    padding: 0px 10px;
                  }

                  &.typing {
                    height: 80px;
                    transition: 500ms ease-in-out;
                  }
                }
              }

              .message-files-options {
                display: flex;
                position: relative;
                height: 30px;

                .btn-emoji {
                  display: flex;
                  align-items: center;
                  margin-right: 8px;
                  height: 30px;

                  img {
                    width: 17px;
                    object-fit: contain;
                  }
                }

                .emoji-widget {
                  position: absolute;
                  bottom: 45px;
                  background: #fff;
                  width: 300px;
                  right: 0px;
                  display: flex;
                  flex-direction: column;
                  border-radius: 5px;
                  box-shadow: 0px 0px 8px rgb(105, 105, 105);

                  .emoji-widget-header {
                    width: 100%;
                    border-bottom: 1px solid #ddd;
                    padding-top: 4px;

                    .emoji-tabs {
                      width: 100%;
                      display: flex;
                      justify-content: space-between;
                      padding: 0px 10px;
                      cursor: pointer;

                      .emoji-tab {
                        .Frequently.used {
                          display: inline-block;
                          width: 34px;
                          height: 28px;
                          background: url(data:image/png;base64,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) no-repeat;
                          background-size: 42px 350px;
                          border: 0;
                          background-position: -9px -306px;

                          &.active {
                            background-position: -9px -277px;
                          }
                        }

                        .People {
                          display: inline-block;
                          width: 34px;
                          height: 28px;
                          background: url(data:image/png;base64,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) no-repeat;
                          background-size: 42px 350px;
                          border: 0;
                          background-position: -9px -34px;

                          &.active {
                            background-position: -9px -5px;
                          }
                        }

                        .Nature {
                          display: inline-block;
                          width: 34px;
                          height: 28px;
                          background: url(data:image/png;base64,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) no-repeat;
                          background-size: 42px 350px;
                          border: 0;
                          background-position: -9px -145px;

                          &.active {
                            background-position: -9px -118px;
                          }
                        }

                        .Objects {
                          display: inline-block;
                          width: 34px;
                          height: 28px;
                          background: url(data:image/png;base64,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) no-repeat;
                          background-size: 42px 350px;
                          border: 0;
                          background-position: -9px -89px;

                          &.active {
                            background-position: -9px -61px;
                          }
                        }

                        .Places {
                          display: inline-block;
                          width: 34px;
                          height: 28px;
                          background: url(data:image/png;base64,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) no-repeat;
                          background-size: 42px 350px;
                          border: 0;
                          background-position: -9px -196px;

                          &.active {
                            background-position: -9px -170px;
                          }
                        }

                        .Symbols {
                          display: inline-block;
                          width: 34px;
                          height: 28px;
                          background: url(data:image/png;base64,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) no-repeat;
                          background-size: 42px 350px;
                          border: 0;
                          background-position: -9px -248px;

                          &.active {
                            background-position: -9px -222px;
                          }
                        }
                      }
                    }
                  }

                  .emoji-widget-body {
                    height: 200px;
                    display: flex;
                    flex-direction: column;

                    .emoji-container {
                      height: 100%;
                      display: flex;
                      flex-direction: column;

                      .search-emoji-widget {
                        height: 40px;
                        display: flex;
                        align-items: center;
                        border-bottom: 1px solid #ddd;
                        padding: 0px 10px;

                        input {
                          border: none;
                          outline: none;
                        }
                      }

                      .emoji-icons-widget {
                        overflow-y: auto;
                        height: calc(100% - 40px);
                        padding: 5px 10px;
                        display: flex;
                        flex-wrap: wrap;

                        span {
                          height: 30px;
                          width: 30px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          padding: 5px;
                          cursor: pointer;
                          transition: transform 400ms ease-in-out;

                          &:hover {
                            transition: transform 400ms ease-in-out;
                            transform: scale(1.5);
                          }
                        }
                      }
                    }
                  }
                }

                .btn-photo {
                  display: flex;
                  align-items: center;
                  margin-right: 8px;
                  height: 30px;

                  img {
                    width: 15px;
                    object-fit: contain;
                  }
                }

                .btn-microphone {
                  display: flex;
                  align-items: center;
                  margin-right: 8px;
                  height: 30px;

                  img {
                    height: 16px;
                    object-fit: contain;
                  }
                }
              }
            }

            .message-option {
              .btn-send {
                width: 45px;
                height: 42px;
                background: #0884af;
                border-radius: 5px;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                  width: 20px;
                  position: relative;
                  top: 1px;
                }
              }
            }
          }
        }

        .message-loading-widget {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;

          .message-loading-header {
            padding: 10px 10px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #fff;

            .profile-image {
              height: 40px;
              width: 40px;
              border-radius: 50%;
              background: #fff;
              margin-right: 10px;
            }

            .profile-content {
              width: calc(100% - 50px);

              .item {
                width: 100%;
                margin-bottom: 5px;
                height: 15px;
                background: #fff;
              }
            }
          }

          .message-loading-body {
            height: 100%;
            padding: 20px;
            overflow-y: hidden;

            .message-list {
              list-style: none;
              padding-left: 0px;
              width: 100%;

              .message-sender {
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                margin-bottom: 10px;
                width: 100%;

                .message-content {
                  width: 70%;
                  background: #fff;
                  border-radius: 6px 6px 6px 0px;
                  padding: 14px;
                  color: #fff;
                  height: 60px;
                  margin-bottom: 4px;
                }

                .massage-time {
                  font-size: 12px;
                  color: #717171;
                }
              }

              .message-receiver {
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                margin-bottom: 10px;
                width: 100%;

                .message-content {
                  width: 70%;
                  background: #fff;
                  border-radius: 6px 6px 0px 6px;
                  padding: 14px;
                  color: #fff;
                  height: 70px;
                  margin-bottom: 4px;
                  align-self: flex-end;
                }

                .massage-time {
                  font-size: 12px;
                  color: #717171;
                  align-self: flex-end;
                }
              }
            }
          }

          .message-loading-footer {
            padding: 10px;

            .item {
              height: 70px;
              width: 100%;
              background: #fff;
            }
          }
        }

        .message-empty-widget {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 30px;

          img.main {}

          h2 {
            margin: 20px 0px;
          }

          p {
            color: #676767;
            text-align: center;
            margin-bottom: 25px;
          }

          .btn-new-message {
            display: flex;
            align-items: center;
            background: #0884af;
            border-radius: 10px;
            font-size: 13px;
            padding: 0px 13px;
            color: #fff;
            height: 40px;
            font-weight: bold;

            img {
              margin-left: 4px;
              margin-right: 5px;
              width: 15px;
              height: 15px;
              position: relative;
              top: 0px;
            }
          }
        }
      }
    }
  }
}

.loading-item {
  border-radius: 5px;
  width: 100%;
  background: rgb(233, 233, 233);
  margin-bottom: 15px;
  padding: 10px;

  .row-2 {
    display: grid;
    grid-template-columns: 48% 48%;
    grid-gap: 10px;
    width: 100%;
    margin-bottom: 10px;

    .item {
      height: 20px;
      background: #fff;
      border-radius: 6px;
    }
  }

  .row {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 10px;
    width: 100%;

    .item {
      background: #fff;
      border-radius: 6px;
    }
  }
}

.pulse {
  opacity: 1;
  animation: pulse 1s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    opacity: 0.3;
  }

  70% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}
</style>


